<script>
import AlertModal from '../AlertModal.vue';
import EmailModal from '../components/EmailModal.vue';
import PasswordModal from '../components/PasswordModal.vue';
import UserNewForm from '../components/UserNewForm.vue';
import SmartHRAttendanceTokenModal from '../components/SmartHRAttendanceTokenModal.vue';
import ProfilePhotoModal from '../components/ProfilePhotoModal.vue';
import { userImageURLInjectKey } from '../../provider/provider.ts';
import { inject } from "vue"

export default {
  props: {
    user: Object,
    thisUser: Object,
    activeUserId: Number,
    changePasswordAndLogin: Boolean,
    enabledSmartHR: {
      type: Boolean,
      default: false,
    },
    profilePhotoEnabled: {
      type: Boolean,
      default: false,
    },
    branchId: {
      type: Number,
      required: true,
    },
    hasSmartHRAttendenceToken: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    openPasswordModal() {
      this.$refs.passwordModal.openModal();
    },
    openEmailModal() {
      this.$refs.emailModal.openModal();
    },
    openSmartHRAttendanceTokenModal() {
      this.$refs.smartHRAttendanceTokenModal?.openModal();
    },
    openAlertModal(message) {
      this.$refs.alertModal?.alert(message);
    },
    openPhotoModal() {
      this.$refs.profilePhotoModal.openModal();
    },
  },
  computed: {
    thisUserForPassword() {
      return {
        hasPassword: this.thisUser.isUserHasPassword,
        id: this.user.ID,
      }
    }
  },
  components: {
    PasswordModal,
    EmailModal,
    UserNewForm,
    SmartHRAttendanceTokenModal,
    AlertModal,
    ProfilePhotoModal,
  },
  setup() {
    const currImageURL = inject(userImageURLInjectKey);
    function updateProfilePhoto(imageURL) {
      currImageURL.value = imageURL;
    }
    return { currImageURL, updateProfilePhoto };
  },
}
</script>

<template>
  <AlertModal ref="alertModal"/>
  
  <PasswordModal 
    ref="passwordModal"
    :thisUser="thisUserForPassword" 
    :activeUserId="user.ID" 
    :changePasswordAndLogin="changePasswordAndLogin"
  >
  </PasswordModal>

  <EmailModal 
    ref="emailModal"
    :email="user.Email" 
    :emailEdit="thisUser.emailEdit" 
  >
  </EmailModal>

  <SmartHRAttendanceTokenModal
    v-if="enabledSmartHR"
    ref="smartHRAttendanceTokenModal"
    :user-id="user.ID"
    :branch-id="branchId"
    @open-alert-modal="openAlertModal"
  />
  <ProfilePhotoModal 
    ref="profilePhotoModal"
    :user-id="user.ID"
    @open-alert-modal="openAlertModal"
    @update-profile-photo="updateProfilePhoto"
  />

  <UserNewForm
    :user="user"
    :thisUser="thisUser"
    :enabled-smart-h-r="enabledSmartHR"
    :has-smart-h-r-attendence-token="hasSmartHRAttendenceToken"
    :image-u-r-l="currImageURL"
    :profile-photo-enabled="profilePhotoEnabled"
    @open-photo-modal="openPhotoModal"
    @open-password-modal="openPasswordModal"
    @open-email-modal="openEmailModal"
    @open-smartHR-attendance-token-modal="openSmartHRAttendanceTokenModal"
  >
  </UserNewForm>
</template>
